import { useEffect } from 'react';
import { ToastContext, ToastContextData } from './toast-context';
import { useToast } from './useToast';
import { ToastBanner } from './ToastBanner';
import { toastEmitter } from '../../services/toast/toastEmitter';

const ToastContextProvider = ({ children }: { children: JSX.Element }) => {
  const { toast, visible, showToast, dismissToast, onExited } = useToast();

  useEffect(() => {
    toastEmitter.register(showToast, dismissToast);
  }, [showToast, dismissToast]);

  return (
    <ToastContext.Provider value={{ showToast, dismissToast }}>
      <div>
        <div className="system-toast" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, overflow: 'hidden', display: visible ? 'block' : 'none' }}>
          <ToastBanner
            toast={toast}
            visible={visible}
            onDismiss={dismissToast}
            onExited={onExited}
          />
        </div>
        {children}
      </div>
    </ToastContext.Provider>
  );
};

export default ToastContextProvider;
